import React, {useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {Button} from "../../../buttons";
import { ReactComponent as CloseCircleFilledIcon } from '../../../../assets/icons/new/UI/CloseCircleFilled.svg';
import PillActionButton from '../../../StocksLayout/PillActionButton';
import ModalBasic from "../../../commons/Modals/ModalBasic";
import stocksExportService from "../../../../api/services/stocksExportService";
import {defaultNotificationCreator} from "../../../../templates/Notifications";
import {setTemporaryNotifications} from "../../../../redux/notifications/actions";
import Number from "../../../commons/Input/Number";
import {t} from "i18next";
import stocksReserveService from "../../../../api/services/stocksReserveService";
import {WarehouseSelector} from "../../../commons/Select/components/WarehouseSelector";

// @ts-ignore
function CancelReservesRecalcAndExportStocksToWarehouses({disabled}) {

    const dispatch = useAppDispatch();

    const [modalOpen, setModalOpen] = React.useState(false);
    
    const { sellerId, userId } = useAppSelector(({ sellers, users }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
        userId: users.currentUser.data.id
    }))

    const [inProcessing, setInProcessing] = useState<boolean>(false)

    const [hours, setHours] = useState<number>(2);
    const [whUUIDs, setWhUUIDs] = useState<string[]>([]);

    function clickHandler(isAll: boolean) {
        setInProcessing(true)
        if (!sellerId || !userId || whUUIDs.length === 0) {
            return;
        }

        stocksReserveService.cancelReserves({
            sellerID: sellerId,
            warehouseIDs: whUUIDs,
            olderThanSeconds: isAll ? 0 : hours * 60 * 60,
            reasonDescription: "web_cancel_reserve",
            initiator: "user",
            IsRecalcDistributedStocks: true
        })
            .then(
                (res) => {
                    if (res.data.success) {
                        dispatch(setTemporaryNotifications(
                            defaultNotificationCreator({
                                title: "Резервы отменены",
                                description: "",
                                iconType: "success"
                            })
                        ))
                        setModalOpen(false)
                        stocksExportService.manuallyRecalcAndExport(sellerId, false, true, true, [])
                    }
                },
                (err) => {
                    dispatch(setTemporaryNotifications(
                        defaultNotificationCreator({
                            title: "Не удалось отменить резервы",
                            description: err.message(),
                            iconType: "warning"
                        })
                    ))
                }
            )
            .catch((err) => {
                dispatch(setTemporaryNotifications(
                    defaultNotificationCreator({
                        title: "Не удалось отменить резервы",
                        description: err.message,
                        iconType: "warning"
                    })
                ))
            })
            .finally(() => setInProcessing(false))
    }

    const changeWarehousesHandler = (data: string|string[]) => {
        console.log(data)
        if(Array.isArray(data)) {
            setWhUUIDs(data)
        } else {
            setWhUUIDs([data.toString()])
        }
    }

    const customInputClassName = 'border-[#E2E8F0] mb-1 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'

    return (
        <>
            <PillActionButton
                icon={CloseCircleFilledIcon}
                label="Отменить резервы"
                title={disabled ? 'Для начала настройте резервирование' : 'Отменить резервы'}
                disabled={disabled}
                loading={inProcessing}
                onClick={() => setModalOpen(true)}
            />
            <ModalBasic id="confirmExportStocksToWarehouses" customSize="max-w-2xl" title="" modalOpen={modalOpen} setModalOpen={setModalOpen}>
                <div className={`p-4 flex flex-col`}>
                    <Number
                        id="hours"
                        name="hours"
                        value={hours}
                        label={t<string>("Отмена резервов старше, часов", {ns: "messages"})}
                        changeHandler={event => setHours(parseInt(event.target.value))}
                        customClassName={customInputClassName}
                        customLabelClassName="text-sm"
                        blurHandler={event => setHours(parseInt(event.target.value))}
                        min={0}
                        require={true}
                    />
                    <WarehouseSelector
                        label={t<string>("Склады", {ns: "messages"})}
                        customLabelClassName="text-sm pt-2"
                        data={whUUIDs}
                        onChange={changeWarehousesHandler}
                        filterFunc={(v: any) => v.status === 'active' && v.isEnableExport}
                        isMultiple={true}
                        validationErrorDescription={whUUIDs.length === 0 ? 'Необходимо выбрать склад' : ''}
                    ></WarehouseSelector>
                    <div className={`pt-4 flex flex-row bottom-0 border-t-[1px] px-2 mt-20`}>
                        <Button
                            appearance="primary"
                            customClassName="button-add px-[50px]"
                            clickHandler={() => clickHandler(false)}
                            loading={inProcessing}
                        >Отменить резервы</Button>
                    </div>
                </div>
            </ModalBasic>
        </>
    );
}

export default CancelReservesRecalcAndExportStocksToWarehouses;
